export default __webpack_public_path__ + "static/media/029-phone-call.980a6af1.png";